<template>
	<v-menu open-on-hover bottom offset-y content-class="tooltip" :close-delay="200">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				tile
				class="batch-button classButton"
				:color="batchColor"
				:dark="batchColor !== 'none'"
				v-bind="attrs"
				v-on="on"
				attach
				@click="clicked"
				ref="batchButton"
				:id="'batch' + batch.id">

				{{ batch.name }}

				<v-avatar class="subject-count" :color="batch.active ? 'white' : 'primary'" size="28" :ripple="true">{{ subjectCount }}</v-avatar>
			</v-btn>
		</template>

		<div class="tooltip-content" ref="menuContent">
			<div v-if="editable">
				<v-btn @click="renameBatch">Rename</v-btn>
				<v-btn class="remove-button" @click="deleteBatch">Delete</v-btn>
			</div>
			<div class="tooltip-header" v-else>
				Click to go to batch
			</div>
		</div>
	</v-menu>
</template>

<script>
export default {
	props: ['batch', 'subjectManagement', 'editable'],
	data: () => ({
		draggingNode: null,
		currentOver: []
	}),
	computed: {
		subjectCount() {
			return this.batch.subjects?.length ?? 0;
		},
		batchColor() {
			if(this.batch.active) {
				return 'primary';
			} else if(this.batch.searching) {
				return 'teal';
			} else {
				return 'none';
			}
		}
	},
	watch: {
		batch() {
			window.$(this.$refs.batchButton.$el).data('batch', this.batch);
		},
		editable() {
			this.setupDroppable();
		}
	},
	methods: {
		clicked() {
			this.subjectManagement.setBatch(this.batch);
		},
		renameBatch() {
			this.subjectManagement.updateBatchName(this.batch);
		},
		deleteBatch() {
			this.subjectManagement.confirmRemoveBatch(this.batch);
		},
		setupDroppable() {
			if(this.editable) {
				if(!$(this.$refs.batchButton.$el).hasClass('ui-droppable')) {
					$(this.$refs.batchButton.$el).addClass('ui-droppable').droppable({
						accept: '.subjectAvatar',
						drop: (event, ui) => {
							if(event.originalEvent.isHandledAlready) {
								return;
							}

							let card = ui.draggable.closest('.subjectCard');
							if(card.hasClass('blue')) {
								let cards = $(this.subjectManagement).find('.subjectCard.blue');

								let subjects = [];
								$.each(cards, function () {
									subjects.push(this.subject);
								});
								this.subjectManagement.addSubjectToBatch(this.batch, subjects);
							} else {
								let subject = card.data('subject');
								this.subjectManagement.addSubjectToBatch(this.batch, subject);
							}
						}
					});
				}
			} else {
				if($(this.$refs.batchButton.$el).hasClass('ui-droppable')) {
					$(this.$refs.batchButton.$el).droppable('destroy');
				}
			}
		}
	},
	mounted() {
		window.$(this.$refs.batchButton.$el).data('batch', this.batch);
		this.setupDroppable();
	}
};
</script>

<style scoped>
.batch-button {
	font-size: 14px;
	text-transform: none;
	cursor: pointer;
	letter-spacing: initial;
}
.batch-button.primary {
	font-weight: bold;
}

.subject-count {
	margin-left: 0.3em;
	cursor: pointer;
	font-size: .85714286rem;
}

.subject-count.white {
	color: var(--v-primary-base);
}
.subject-count.primary {
	color: rgb(255, 255, 255);
}

.tooltip {
	background-color: white;
	color: black;
}
.tooltip-content {
	margin: 0.8em;
}
.tooltip-header {
	font-weight: bold;
}

.remove-button {
	margin-left: 1em;
}
</style>